import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-29b693a6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "properties" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HomeCalculatorPropertiesHeader = _resolveComponent("HomeCalculatorPropertiesHeader")!
  const _component_HomeCalculatorPropertiesList = _resolveComponent("HomeCalculatorPropertiesList")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HomeCalculatorPropertiesHeader),
    _createVNode(_component_HomeCalculatorPropertiesList)
  ]))
}